import { useEffect, useCallback } from "react";
import throttle from "lodash/throttle";

const getContainer = (ref) => ref?.current || document.getElementById("right-window") || window;

export const useInfiniteScroll = (callback, offset = 0, ref, inverse = false) => {
  const handleScroll = useCallback(
    (event) => {
      let { target } = event;

      const container = getContainer(ref);

      let top = target?.scrollTop || 0;
      let height = target?.scrollHeight || 0;
      let clientHeight = container?.clientHeight || 0;

      if (target === document) {
        const body = document.body; // Safari
        const html = document.documentElement; // Other normal browsers
        top = Math.max(body.scrollTop, html.scrollTop);
        height = Math.max(body.scrollHeight, html.scrollHeight);
        clientHeight = html.clientHeight;
      }

      const requirements = !inverse ? top >= height - clientHeight - offset : top <= offset;

      if (typeof callback === "function" && requirements) {
        callback();
      }
    },
    [ref, inverse, offset, callback]
  );

  useEffect(() => {
    const listener = throttle(handleScroll, 500);

    const container = getContainer(ref);

    container?.addEventListener("scroll", listener);

    return () => {
      // cancel running throttle to prevent call
      // to set state on unmounted component
      listener.cancel();
      container?.removeEventListener("scroll", listener);
    };
  }, [handleScroll, ref]);
};
